export default {
  nav: {
    technology: "ODF-Technologie",
    solutions: "Lösungen",
    partnerships: "Partnerschaften",
    about: "Über uns",
    contact: "Kontakt",
    home: "Startseite",
  },
  hero: {
    eyebrow: "ODF-LÖSUNGEN DER NÄCHSTEN GENERATION",
    headline1: "Innovation,",
    headline2: "in jedem Film spürbar.",
    copy: "NORTIS bringt fortschrittliche Schmelzfilme (Orally Dissolving Films, ODF) zu modernen Wellness-Marken und auf internationale Märkte – und verbindet ein praktisches Format mit verlässlicher kommerzieller Expertise.",
    cta1: "ODF-Technologie entdecken",
    cta2: "Partner von NORTIS werden",
    trust: "Entwickelt für moderne Lebensstile. Geschaffen für globale Chancen.",
    scroll: "Scrollen",
  },
  brandline: "Fortschrittliche Darreichung. Mühelose Erfahrung.",
  credibility: {
    title: "Ein intelligenteres Format für eine Welt im Wandel.",
    copy: "Schmelzfilme bieten eine elegante und praktische Möglichkeit, sorgfältig formulierte Inhaltsstoffe darzureichen – ohne das gewohnte Erlebnis von Tabletten, Kapseln oder Flüssigkeiten.",
  },
  whatIsOdf: {
    eyebrow: "DAS FORMAT",
    title: "Was ist ODF?",
    copy: "Ein ODF ist ein hauchdünner oraler Film, der sich bequem im Mund auflöst. Sein kompaktes Format bietet Marken, die mobile und benutzerfreundliche Wellness-Erlebnisse entwickeln, eine moderne Alternative.",
    benefits: [
      { title: "Dünn und mobil", desc: "Ein ultraflaches Format, das mühelos mitreist – in der Tasche, im Portemonnaie oder in der Handtasche." },
      { title: "Anwendung ohne Wasser", desc: "Konzipiert für die Verwendung überall und jederzeit – ganz ohne Wasser oder Vorbereitung." },
      { title: "Präzise Einzeldarreichung", desc: "Jeder Film ist eine einzeln präsentierte Einheit, verpackt für gleichbleibende Qualität." },
      { title: "Gemacht für Innovation", desc: "Eine flexible Grundlage für moderne Produktkonzepte und differenzierte Markenerlebnisse." },
    ],
  },
  whyNortis: {
    eyebrow: "WARUM NORTIS",
    title: "Mehr als ein Produktformat. Eine vollständige Marktchance.",
    copy: "NORTIS ist die Brücke zwischen ODF-Innovation und kommerziellen Märkten – und verbindet vielversprechende Produkte mit Partnern, die sie skalieren können.",
    points: [
      { title: "Kommerzielle ODF-Expertise", desc: "Ein klarer Fokus auf die Kategorie der Schmelzfilme und ihre kommerzielle Dynamik." },
      { title: "Internationale Beschaffung und Markterschließung", desc: "Chancen erkennen und Wege in die Märkte verschiedener Regionen aufbauen." },
      { title: "Unterstützung bei Produkt- und Markenpositionierung", desc: "Wir helfen Partnern, ODF-Konzepte für ihre Zielgruppen und Vertriebskanäle zu gestalten." },
      { title: "Flexible B2B-Partnerschaftsmodelle", desc: "Vertrieb, Private Label und Marktentwicklung – strukturiert nach Ihren Zielen." },
      { title: "Qualitätsbewusste Auswahl", desc: "Disziplinierte Prüfung von Eignung, Dokumentation und Marktreife." },
      { title: "Langfristige Beziehungen", desc: "Partnerschaften, die auf nachhaltiges und wachsendes Geschäft ausgelegt sind." },
    ],
  },
  solutions: {
    eyebrow: "LÖSUNGSPORTFOLIO",
    title: "Ein Portfolio, gestaltet für das moderne Leben.",
    copy: "Entdecken Sie die Lösungskategorien, die NORTIS gemeinsam mit Partnern und Märkten weltweit entwickelt.",
    viewAll: "Alle Lösungen ansehen",
    requestInfo: "Produktinformationen anfordern",
    possibilitiesLabel: "Entwicklungsmöglichkeiten",
    positioningLabel: "Kommerzielle Positionierung",
    availabilityLabel: "Marktverfügbarkeit",
    targetLabel: "Zielmarkt",
    docLabel: "Dokumentationsstatus",
    sheetLabel: "Informationsblatt",
    sheetOnRequest: "Auf Anfrage erhältlich",
    demoBadge: "Demonstrationskonzept",
    filterAll: "Alle",
    pageTitle: "Lösungen",
    pageSub: "Ein filterbares Portfolio von ODF-Lösungskategorien – so strukturiert, dass reale Produkte im Zuge wachsender Partnerschaften ergänzt werden können.",
    demoNote: "Die folgenden Einträge sind Demonstrationskonzepte, die die Ausrichtung der Kategorien veranschaulichen. Tatsächliche kommerzielle Produkte werden im Rahmen aktiver Partnerschaften vorgestellt.",
  },
  comparison: {
    eyebrow: "FORMAT IM VERGLEICH",
    title: "So schneidet das Filmformat im Vergleich ab.",
    copy: "Ein neutraler Blick auf die praktischen Eigenschaften gängiger Darreichungsformen.",
    note: "Ausschließlich ein neutraler Vergleich praktischer Formateigenschaften. Keine Aussage über klinische Leistung oder Wirksamkeit.",
    formats: ["ODF-Film", "Tabletten", "Kapseln", "Flüssigkeiten"],
    rows: [
      { label: "Mobilität", values: [2, 2, 2, 0] },
      { label: "Anwendung ohne Wasser", values: [2, 0, 0, 1] },
      { label: "Einzeln vorportioniertes Format", values: [2, 2, 2, 0] },
      { label: "Einfache Aufbewahrung", values: [2, 2, 1, 0] },
      { label: "Diskrete Anwendung unterwegs", values: [2, 1, 1, 0] },
    ],
  },
  models: {
    eyebrow: "PARTNERSCHAFTSMODELLE",
    title: "Drei Wege, mit NORTIS zu wachsen.",
    cta: "Partnerschaft besprechen",
    items: [
      { title: "Vertrieb", desc: "Bringen Sie ausgewählte ODF-Produkte in neue Regionen und Handelsnetzwerke." },
      { title: "Private Label", desc: "Entwickeln Sie differenzierte ODF-Konzepte unter Ihrer eigenen Marke." },
      { title: "Marktentwicklung", desc: "Gestalten Sie gemeinsam mit NORTIS Produktpositionierung, Launch-Strategie und langfristige Marktpräsenz." },
    ],
  },
  timeline: {
    eyebrow: "SO FUNKTIONIERT DIE ZUSAMMENARBEIT",
    title: "Vom ersten Gespräch bis zum Marktwachstum.",
    steps: [
      { title: "Chancenanalyse", desc: "Wir betrachten Ihre Ziele, Ihre Märkte und die passenden ODF-Konzepte." },
      { title: "Produkt- und Marktabstimmung", desc: "Die richtigen Produkte im richtigen kommerziellen Kontext." },
      { title: "Kommerzielle Bewertung", desc: "Konditionen, Volumina und ein realistischer kommerzieller Rahmen." },
      { title: "Compliance und Launch-Vorbereitung", desc: "Prüfung der Dokumentation und Marktanforderungen vor dem Start." },
      { title: "Vertrieb und Wachstum", desc: "Begleitung von Markteinführung, Expansion und langfristigem Partnerschaftswachstum." },
    ],
  },
  quality: {
    eyebrow: "QUALITÄT UND VERANTWORTUNG",
    title: "Qualität beginnt mit den richtigen Fragen.",
    copy: "NORTIS prüft im Rahmen jeder potenziellen Partnerschaft die Produkteignung, die Dokumentation, die kommerzielle Reife und die Marktanforderungen. Verfügbarkeit und regulatorischer Status der Produkte können je nach Land variieren.",
    placeholder: "Geprüfte Qualitätsdokumentationen und Zertifizierungen werden hier veröffentlicht, sobald Partnerschaften voranschreiten.",
  },
  global: {
    eyebrow: "GLOBALE AUSRICHTUNG",
    title: "Gemacht für internationale Zusammenarbeit",
    copy: "Wir arbeiten mit Marken, Lieferanten, Distributoren und Handelspartnern zusammen, um in dynamischen globalen Märkten relevante ODF-Chancen zu identifizieren.",
  },
  finalCta: {
    title: "Gestalten wir gemeinsam die nächste Generation des oralen Wellness.",
    copy: "Ob Vertrieb, Private Label oder ein neues ODF-Produktkonzept – NORTIS ist bereit für das Gespräch.",
    cta: "Gespräch beginnen",
  },
  footer: {
    desc: "NORTIS verbindet innovative ODF-Produkte mit Marken, Partnern und Märkten weltweit.",
    nav: "Navigation",
    legal: "Rechtliches",
    privacy: "Datenschutzerklärung",
    terms: "Nutzungsbedingungen",
    language: "Sprache",
    disclaimer: "Verfügbarkeit, Formulierung, Klassifizierung und regulatorischer Status der Produkte können je nach Land variieren. Die Informationen auf dieser Website dienen kommerziellen und allgemeinen Informationszwecken und stellen keine medizinische Beratung dar.",
    rights: "Alle Rechte vorbehalten.",
  },
  tech: {
    eyebrow: "ODF-TECHNOLOGIE",
    title: "Die Wissenschaft des Dünnen.",
    sub: "Ein informativer Überblick über Schmelzfilme – das Format, das Anwendungserlebnis und die kommerziellen Möglichkeiten, die es eröffnet.",
    what: {
      title: "Was ist ein Schmelzfilm?",
      copy: "Ein Schmelzfilm (Orally Dissolving Film, ODF) ist eine hauchdünne Schicht, die sich bequem im Mund auflöst. Anstatt eine Tablette zu schlucken oder eine Flüssigkeit abzumessen, legt der Anwender einfach einen einzelnen Film in den Mund und lässt ihn sich auflösen – ein unaufdringliches, modernes Erlebnis in einem bemerkenswert kompakten Format.",
    },
    structure: {
      title: "Der grundlegende Filmaufbau",
      copy: "Konzeptionell vereint ein ODF eine strukturelle Filmbasis, eine Trägermatrix mit den formulierten Inhaltsstoffen und eine sensorische Schicht, die Geschmack und Textur prägt. Bewegen Sie den Mauszeiger über das Diagramm oder tippen Sie darauf, um die konzeptionellen Schichten zu trennen.",
      note: "Konzeptionelle Darstellung, nur zur Veranschaulichung.",
      layers: [
        { title: "Sensorische Schicht", desc: "Prägt Geschmack, Textur und das Auflösungserlebnis." },
        { title: "Trägermatrix", desc: "Trägt die sorgfältig formulierten Inhaltsstoffe im Film." },
        { title: "Strukturelle Basis", desc: "Verleiht dem Film Stabilität, Dünnheit und Beständigkeit." },
      ],
    },
    experience: {
      title: "Das Anwendungserlebnis",
      copy: "Kein Wasser. Kein Abmessen. Keine Unterbrechung. Ein Film löst sich diskret auf und lässt sich ganz natürlich auf Reisen, bei der Arbeit oder unterwegs anwenden. Für moderne Konsumenten wird das Format selbst zum Teil des Markenerlebnisses.",
    },
    portability: {
      title: "Mobilität und Verpackungspotenzial",
      copy: "Einzelne Filme lassen sich in schlanken Sachets, eleganten Mehrfachpackungen oder kompakten Spendern präsentieren – Formate, die sowohl in moderne Handelsregale als auch in Direct-to-Consumer-Unboxing-Momente passen.",
    },
    development: {
      title: "Möglichkeiten der Produktentwicklung",
      copy: "Das Filmformat unterstützt ein breites Spektrum an Produktkonzepten – von täglichen Wellness-Routinen bis hin zu gezielter Lifestyle-Positionierung – und eröffnet Marken Raum zur Differenzierung in umkämpften Kategorien.",
    },
    commercial: {
      title: "Kommerzielle Anwendungsfelder",
      copy: "ODF-Konzepte werden in den Kategorien Wellness, Beauty-from-within, Energie, Schlaf und funktionelle Inhaltsstoffe entwickelt – in Kanälen, in denen Komfort und Premium-Erlebnis die Kaufentscheidung prägen.",
    },
    regulatory: {
      title: "Markt- und regulatorische Aspekte",
      copy: "Klassifizierung und Anforderungen für Filmprodukte unterscheiden sich je nach Land und Formulierung. NORTIS betrachtet jeden Markt individuell und prüft Dokumentation und regulatorischen Rahmen gemeinsam mit den Partnern vor der Kommerzialisierung.",
    },
    cta: "Technische Informationen anfordern",
  },
  partnership: {
    eyebrow: "PRIVATE LABEL UND VERTRIEB",
    title: "Zwei Wege. Ein Anspruch an Partnerschaft.",
    sub: "NORTIS strukturiert kommerzielle Kooperationen um zwei zentrale Modelle – beide ausgelegt auf Klarheit, Geschwindigkeit und langfristiges Wachstum.",
    plTitle: "Private Label",
    plDesc: "Entwickeln Sie differenzierte ODF-Konzepte unter Ihrer eigenen Marke – NORTIS koordiniert den Weg vom Konzept bis ins Regal.",
    plSteps: ["Konzeptbewertung", "Produktauswahl", "Branding- und Verpackungskoordination", "Prüfung der Dokumentation", "Vorbereitung der Markteinführung", "Kommerzielle Skalierung"],
    distTitle: "Vertrieb",
    distDesc: "Bringen Sie ausgewählte ODF-Produkte in Ihre Region und Ihr Handelsnetzwerk – mit strukturierter Unterstützung in jeder Phase.",
    distSteps: ["Gebietsbewertung", "Portfolioabstimmung", "Kommerzielle Konditionen", "Planung des Markteintritts", "Launch-Unterstützung", "Langfristiges Wachstum"],
    formTitle: "Partnerschaftsanfrage stellen",
    formSub: "Teilen Sie uns Ihre Ziele mit – unser Team meldet sich mit den nächsten Schritten.",
  },
  about: {
    eyebrow: "ÜBER NORTIS",
    title: "Fokussiert auf das Format, das die Zukunft prägt.",
    copy: "NORTIS wurde gegründet, um vielversprechende ODF-Innovationen mit den Marken, Partnern und Märkten zu verbinden, die daraus bedeutende kommerzielle Produkte machen können. Wir vereinen unternehmerische Geschwindigkeit, internationales Denken und einen disziplinierten Ansatz für langfristige Partnerschaften.",
    positioning: "NORTIS verbindet innovative ODF-Produkte mit Marken, Partnern und Märkten weltweit.",
    principlesTitle: "Unsere Prinzipien",
    principles: [
      { title: "Präzision", desc: "Sorgfalt in jedem Detail – von der Produktbewertung bis zur Partnerkommunikation." },
      { title: "Vertrauen", desc: "Transparente Erwartungen und Zusagen, zu denen wir stehen." },
      { title: "Fortschritt", desc: "Eine klare Ausrichtung auf Weiterentwicklung und moderne Formate." },
      { title: "Partnerschaft", desc: "Beziehungen, die über Jahre wachsen – nicht nur über Quartale." },
      { title: "Globale Perspektive", desc: "Denken über Grenzen, Märkte und Konsumkulturen hinweg." },
    ],
  },
  contact: {
    eyebrow: "KONTAKT",
    title: "Beginnen wir das Gespräch.",
    sub: "Teilen Sie uns einige Details zu Ihrem Anliegen mit – unser Team meldet sich bei Ihnen.",
    name: "Vollständiger Name",
    company: "Unternehmen",
    email: "Geschäftliche E-Mail",
    country: "Land",
    website: "Website",
    interest: "Interesse an Partnerschaft",
    market: "Angestrebter Markt oder Region",
    message: "Nachricht",
    consent: "Ich willige ein, dass NORTIS meine Angaben speichert, um diese Anfrage zu beantworten.",
    submit: "Nachricht senden",
    sending: "Wird gesendet…",
    successTitle: "Vielen Dank — Ihre Nachricht ist eingegangen.",
    successCopy: "Unser Team prüft Ihre Anfrage und meldet sich in Kürze bei Ihnen.",
    successAnother: "Weitere Nachricht senden",
    errorRequired: "Dieses Feld ist erforderlich.",
    errorEmail: "Bitte geben Sie eine gültige geschäftliche E-Mail-Adresse ein.",
    errorConsent: "Zum Absenden des Formulars ist Ihre Einwilligung erforderlich.",
    errorSubmit: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    optional: "Optional",
    interests: {
      distribution: "Vertrieb",
      privateLabel: "Private Label",
      sourcing: "Produktbeschaffung",
      marketDev: "Marktentwicklung",
      general: "Allgemeine Partnerschaft",
      product: "Produktinformationen",
      technical: "Technische Informationen",
    },
    selectPlaceholder: "Bitte auswählen",
  },
  legal: {
    privacyTitle: "Datenschutzerklärung",
    termsTitle: "Nutzungsbedingungen",
    updated: "Zuletzt aktualisiert",
    privacy: [
      { h: "1. Überblick", p: "Diese Datenschutzerklärung erläutert, wie NORTIS über diese Website übermittelte Informationen erhebt, verwendet und schützt. Wir verpflichten uns, geschäftliche Kontaktdaten verantwortungsvoll und transparent zu verarbeiten." },
      { h: "2. Erhobene Daten", p: "Wenn Sie ein Kontakt- oder Partnerschaftsformular absenden, erfassen wir die von Ihnen bereitgestellten Angaben, etwa Name, Unternehmen, geschäftliche E-Mail-Adresse, Land, Website, Interessengebiet und Nachrichteninhalt." },
      { h: "3. Verwendung der Daten", p: "Übermittelte Daten werden ausschließlich verwendet, um Ihre Anfrage zu beantworten, eine mögliche kommerzielle Zusammenarbeit zu prüfen und mit Ihnen zu relevanten Partnerschaftsthemen zu kommunizieren. Wir verkaufen keine personenbezogenen Daten." },
      { h: "4. Datenspeicherung und Sicherheit", p: "Formulareingaben werden sicher in unserer Anwendungsdatenbank gespeichert. Der Zugriff ist auf Mitarbeitende beschränkt, die ihn zur Beantwortung von Anfragen benötigen. Wir treffen angemessene technische Maßnahmen zum Schutz gespeicherter Daten." },
      { h: "5. Aufbewahrungsdauer", p: "Wir bewahren Anfragedaten so lange auf, wie es für die Verwaltung der Geschäftsbeziehung erforderlich ist oder geltendes Recht es verlangt. Die Löschung Ihrer Daten können Sie jederzeit bei uns beantragen." },
      { h: "6. Ihre Rechte", p: "Abhängig von Ihrem Rechtsraum haben Sie gegebenenfalls das Recht auf Auskunft über, Berichtigung oder Löschung der von uns über Sie gespeicherten personenbezogenen Daten. Zur Ausübung dieser Rechte kontaktieren Sie uns bitte über die Website." },
      { h: "7. Änderungen dieser Erklärung", p: "Wir können diese Datenschutzerklärung von Zeit zu Zeit aktualisieren. Wesentliche Änderungen werden auf dieser Seite mit aktualisiertem Revisionsdatum ausgewiesen." },
    ],
    terms: [
      { h: "1. Annahme der Bedingungen", p: "Durch den Zugriff auf diese Website und ihre Nutzung erklären Sie sich mit diesen Nutzungsbedingungen einverstanden. Wenn Sie nicht einverstanden sind, stellen Sie die Nutzung der Website bitte ein." },
      { h: "2. Informationszweck", p: "Die Inhalte dieser Website dienen ausschließlich kommerziellen und allgemeinen Informationszwecken. Sie stellen keine medizinische, rechtliche oder regulatorische Beratung dar, und kein Inhalt ist als Produktversprechen zu verstehen." },
      { h: "3. Produktverfügbarkeit", p: "Verfügbarkeit, Formulierung, Klassifizierung und regulatorischer Status der Produkte können je nach Land variieren. Nichts auf dieser Website stellt ein Angebot zum Verkauf eines Produkts in einem bestimmten Rechtsraum dar." },
      { h: "4. Geistiges Eigentum", p: "Der Name NORTIS, die visuelle Identität und die Inhalte dieser Website sind Eigentum von NORTIS. Ohne vorherige schriftliche Genehmigung dürfen Sie Inhalte der Website weder vervielfältigen noch verbreiten." },
      { h: "5. Haftungsbeschränkung", p: "NORTIS bemüht sich in angemessenem Umfang, die Informationen auf der Website aktuell und korrekt zu halten, übernimmt jedoch keine Gewähr für deren Vollständigkeit. Soweit gesetzlich zulässig, haftet NORTIS nicht für Entscheidungen, die auf Grundlage der Website-Inhalte getroffen werden." },
      { h: "6. Links zu Dritten", p: "Diese Website kann Links zu Ressourcen Dritter enthalten. NORTIS ist für die Inhalte oder Praktiken externer Websites nicht verantwortlich." },
      { h: "7. Geltung der Bedingungen", p: "Diese Bedingungen können regelmäßig aktualisiert werden. Die fortgesetzte Nutzung der Website gilt als Annahme der jeweils aktuellen Fassung." },
    ],
  },
  seo: {
    home: { title: "NORTIS — Fortschrittliche ODF-Lösungen | Ihr Partner für Schmelzfilme", desc: "NORTIS verbindet innovative Schmelzfilm-Produkte (ODF) mit Marken, Partnern und Märkten weltweit. Vertrieb, Private Label und Marktentwicklung." },
    tech: { title: "ODF-Technologie — NORTIS", desc: "Ein informativer Überblick über die Schmelzfilm-Technologie: Format, Aufbau, Anwendungserlebnis und kommerzielle Möglichkeiten." },
    solutions: { title: "ODF-Lösungsportfolio — NORTIS", desc: "Entdecken Sie ODF-Lösungskategorien: tägliches Wellness, Energie, Beauty, Schlaf, funktionelle Inhaltsstoffe und individuelle Private-Label-Konzepte." },
    partnership: { title: "Private Label und Vertrieb — NORTIS", desc: "Werden Sie Partner von NORTIS – über Vertriebs-, Private-Label- oder Marktentwicklungsmodelle für ODF-Produkte." },
    about: { title: "Über NORTIS — Fokussiert auf das Format der Zukunft", desc: "NORTIS verbindet vielversprechende ODF-Innovationen mit Marken, Partnern und Märkten, die daraus kommerzielle Produkte machen können." },
    contact: { title: "NORTIS kontaktieren — Gespräch beginnen", desc: "Kontaktieren Sie das NORTIS-Team zu ODF-Vertrieb, Private Label, Beschaffung oder Marktentwicklung." },
    privacy: { title: "Datenschutzerklärung — NORTIS", desc: "Wie NORTIS über diese Website übermittelte Informationen erhebt, verwendet und schützt." },
    terms: { title: "Nutzungsbedingungen — NORTIS", desc: "Bedingungen für die Nutzung der NORTIS-Website und ihrer Informationsinhalte." },
  },
  a11y: {
    mainNav: "Hauptnavigation",
    mobileNav: "Mobile Navigation",
    homeLink: "NORTIS Startseite",
    openMenu: "Menü öffnen",
    closeMenu: "Menü schließen",
    langSelector: "Sprache auswählen",
    filmDiagram: "Interaktives Filmschichten-Diagramm",
    linkedinLabel: "NORTIS auf LinkedIn",
    techImageAlt: "Abstrakte, geschichtete Filmblätter",
    yes: "Ja",
    partial: "Teilweise",
    no: "Nein",
    filters: "Lösungsfilter",
  },
  solutionsData: {
    "daily-wellness": {
      name: "Tägliches Wellness",
      desc: "Alltagstaugliche Filmkonzepte, die sich natürlich in moderne Morgen- und Abendroutinen einfügen.",
      possibilities: ["Routinenbasierte Produktlinien", "Abo-freundliche Formate", "Minimalistische Premium-Verpackung"],
      positioning: "Positioniert für Konsumenten, die mühelose tägliche Beständigkeit suchen.",
      availability: "In Entwicklung mit Partnern",
      targetMarket: "Wellness- und Lifestyle-Handel",
      docStatus: "Je Markt vorbereitet",
    },
    "energy-performance": {
      name: "Energie & Leistung",
      desc: "Konzepte für unterwegs – für Konsumenten, die Schwung schätzen: vor dem Training, auf Reisen oder an anspruchsvollen Tagen.",
      possibilities: ["Positionierung vor Aktivitäten", "Kompakte Mehrfachpack-Formate", "Mutige, moderne Markensprache"],
      positioning: "Gemacht für schnelle, komfortorientierte Konsummomente.",
      availability: "In Entwicklung mit Partnern",
      targetMarket: "Active-Lifestyle- und Sportkanäle",
      docStatus: "Je Markt vorbereitet",
    },
    "beauty-aging": {
      name: "Beauty & gesundes Altern",
      desc: "Elegante Filmkonzepte für die Kategorie Beauty-from-within, in der Erlebnis und Ästhetik zählen.",
      possibilities: ["Premium-Beauty-Positionierung", "Verschenkbare Verpackungskonzepte", "Ritualgeführtes Marken-Storytelling"],
      positioning: "Ein edles Format für Marken, die das tägliche Beauty-Ritual aufwerten.",
      availability: "In Entwicklung mit Partnern",
      targetMarket: "Beauty-from-within und Premium-Handel",
      docStatus: "Je Markt vorbereitet",
    },
    "sleep-relaxation": {
      name: "Schlaf & Entspannung",
      desc: "Ruhige, auf den Abend ausgerichtete Konzepte, gestaltet für Einfachheit am Ende des Tages.",
      possibilities: ["Positionierung als Abendritual", "Diskrete Formate für den Nachttisch", "Beruhigendes sensorisches Design"],
      positioning: "Gemacht für den stillen Moment vor der Ruhe.",
      availability: "In Entwicklung mit Partnern",
      targetMarket: "Abend-Wellness und Apothekenhandel",
      docStatus: "Je Markt vorbereitet",
    },
    "vitamins-functional": {
      name: "Vitamine & funktionelle Inhaltsstoffe",
      desc: "Filmkonzepte rund um etablierte funktionelle Inhaltsstoffe, präsentiert in einem präzisen, modernen Format.",
      possibilities: ["Inhaltsstoffgeführte Produktfamilien", "Klares, ehrliches Etikettendesign", "Differenzierung über das Format"],
      positioning: "Eine zeitgemäße Alternative in etablierten Inhaltsstoffkategorien.",
      availability: "In Entwicklung mit Partnern",
      targetMarket: "Nutraceutical- und Functional-Handel",
      docStatus: "Je Markt vorbereitet",
    },
    "custom-private-label": {
      name: "Individuelle & Private-Label-Konzepte",
      desc: "Eine leere Leinwand: maßgeschneiderte ODF-Konzepte unter der Marke des Partners – von der Idee bis zum Launch.",
      possibilities: ["Vollständig individuelle Konzeptentwicklung", "Marken- und Verpackungskoordination", "Launch- und Skalierungsunterstützung"],
      positioning: "Für Partner, die ein differenziertes Produkt wollen, das unverwechselbar ihres ist.",
      availability: "Offen für Briefings",
      targetMarket: "Markeninhaber und Händler",
      docStatus: "Je Projekt definiert",
    },
  },
};
